/**
 * This file is autogenerated by py_nats_stub_gen
 * Do not edit this file manually!!
 * => Instead, re-generate it. Check the py-nats-stub-gen repo for more info
 **/
import type { ApiCaller } from "../../wire/ApiCaller";
import type { CamelToSnake } from "../../wire/transform";
import type {
  CreateLinkTypeRequest,
  CreateLinkTypeResponse,
  GetAlmItemTypeForStickyRequest,
  GetAlmItemTypeForStickyResponse,
  GetAlmItemTypeRequest,
  GetAlmItemTypeResponse,
  GetAlmTypesResponse,
  GetAlmUserResponse,
  GetArtTeamFieldMappingResponse,
  GetDevLinksRequest,
  GetDevLinksResponse,
  GetIterationStatusRequest,
  GetIterationStatusResponse,
  GetJiraBoardsRequest,
  GetJiraBoardsResponse,
  GetJiraKanbanBoardResponse,
  GetJiraKanbanConfigRequest,
  GetJiraKanbanConfigResponse,
  GetJiraMappingResponse,
  GetKanbanConfigsRequest,
  GetKanbanConfigsResponse,
  GetProjectSourcesResponse,
  GetTeamFieldMappingsResponse,
  LoadAlmItemTypesRequest,
  LoadAlmItemTypesResponse,
  NoData,
  SearchAlmUsersRequest,
  SearchAlmUsersResponse,
  SetAlmTypeRequest,
  SetAlmUserRequest,
  SetArtTeamFieldMappingRequest,
  SetJiraKanbanBoardRequest,
  SetJiraMappingRequest,
  SetTeamFieldMappingsRequest,
  StartIterationSyncRequest,
  StartIterationSyncResponse,
  StartProgramBacklogSyncRequest,
  StartProgramBacklogSyncResponse,
  StartSessionResponse,
  SyncStickyRequest,
} from "../models";
import {
  createLinkTypeResponseSchema,
  getAlmUserResponseSchema,
  getArtTeamFieldMappingResponseSchema,
  getDevLinksResponseSchema,
  getIterationStatusResponseSchema,
  getJiraBoardsResponseSchema,
  getJiraKanbanBoardResponseSchema,
  getJiraKanbanConfigResponseSchema,
  getJiraMappingResponseSchema,
  getKanbanConfigsResponseSchema,
  getTeamFieldMappingsResponseSchema,
  loadAlmItemTypesResponseSchema,
  noDataSchema,
  searchAlmUsersResponseSchema,
  startIterationSyncResponseSchema,
  startProgramBacklogSyncResponseSchema,
  startSessionResponseSchema,
} from "../schemas";

export class AlmsyncJiraApiClient {
  constructor(private caller: ApiCaller) {}

  async start(sessionId: string, timeout?: number): Promise<StartSessionResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.jira.sessions.${sessionId}.sync.start",
        variables: { sessionId: String(sessionId) },
      },
      "start",
      {},
      { schema: startSessionResponseSchema, timeout },
    );
  }

  async restart(sessionId: string, timeout?: number): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.jira.sessions.${sessionId}.sync.restart",
        variables: { sessionId: String(sessionId) },
      },
      "restart",
      {},
      { schema: noDataSchema, timeout },
    );
  }

  async forceRunning(sessionId: string, timeout?: number): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.jira.sessions.${sessionId}.sync.force.start",
        variables: { sessionId: String(sessionId) },
      },
      "forceRunning",
      {},
      { schema: noDataSchema, timeout },
    );
  }

  async setAlmType(
    payload: CamelToSnake<SetAlmTypeRequest>,
    sessionId: string,
    timeout?: number,
  ): Promise<CamelToSnake<NoData>> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.jira.sessions.${sessionId}.alm_type.set",
        variables: { sessionId: String(sessionId) },
      },
      "setAlmType",
      payload,
      { rawRequest: true, timeout },
    );
  }

  async getAlmTypes(
    sessionId: string,
    timeout?: number,
  ): Promise<CamelToSnake<GetAlmTypesResponse>> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.jira.sessions.${sessionId}.alm_types.get",
        variables: { sessionId: String(sessionId) },
      },
      "getAlmTypes",
      {},
      { timeout },
    );
  }

  async getAlmItemType(
    payload: GetAlmItemTypeRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<CamelToSnake<GetAlmItemTypeResponse>> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.jira.sessions.${sessionId}.alm_item_type.get",
        variables: { sessionId: String(sessionId) },
      },
      "getAlmItemType",
      payload,
      { timeout },
    );
  }

  async getAlmItemTypeForSticky(
    payload: GetAlmItemTypeForStickyRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<CamelToSnake<GetAlmItemTypeForStickyResponse>> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.jira.sessions.${sessionId}.alm_item_type.for_sticky.get",
        variables: { sessionId: String(sessionId) },
      },
      "getAlmItemTypeForSticky",
      payload,
      { timeout },
    );
  }

  async loadAlmItemTypes(
    payload: LoadAlmItemTypesRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<LoadAlmItemTypesResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.jira.connections.${connectionId}.alm_item_types.load",
        variables: { connectionId: String(connectionId) },
      },
      "loadAlmItemTypes",
      payload,
      { schema: loadAlmItemTypesResponseSchema, timeout },
    );
  }

  async createLinkType(
    payload: CreateLinkTypeRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<CreateLinkTypeResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.jira.sessions.${sessionId}.link_types.create",
        variables: { sessionId: String(sessionId) },
      },
      "createLinkType",
      payload,
      { schema: createLinkTypeResponseSchema, timeout },
    );
  }

  async getJiraSessionTeamFieldMappings(
    sessionId: string,
    timeout?: number,
  ): Promise<GetTeamFieldMappingsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.jira.sessions.${sessionId}.team_field_mappings.get",
        variables: { sessionId: String(sessionId) },
      },
      "getJiraSessionTeamFieldMappings",
      {},
      { schema: getTeamFieldMappingsResponseSchema, timeout },
    );
  }

  async setJiraSessionTeamFieldMappings(
    payload: SetTeamFieldMappingsRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.jira.sessions.${sessionId}.team_field_mappings.set",
        variables: { sessionId: String(sessionId) },
      },
      "setJiraSessionTeamFieldMappings",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getIterationStatus(
    payload: GetIterationStatusRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<GetIterationStatusResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.jira.sessions.${sessionId}.iterations_sync.get",
        variables: { sessionId: String(sessionId) },
      },
      "getIterationStatus",
      payload,
      { schema: getIterationStatusResponseSchema, timeout },
    );
  }

  async startIterationsSync(
    payload: StartIterationSyncRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<StartIterationSyncResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.jira.sessions.${sessionId}.iterations_sync.start",
        variables: { sessionId: String(sessionId) },
      },
      "startIterationsSync",
      payload,
      { schema: startIterationSyncResponseSchema, timeout },
    );
  }

  async startSyncProgramBacklog(
    payload: StartProgramBacklogSyncRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<StartProgramBacklogSyncResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.jira.sessions.${sessionId}.sync_program_backlog.start",
        variables: { sessionId: String(sessionId) },
      },
      "startSyncProgramBacklog",
      payload,
      { schema: startProgramBacklogSyncResponseSchema, timeout },
    );
  }

  async getAlmUsers(
    payload: SearchAlmUsersRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<SearchAlmUsersResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.jira.sessions.${sessionId}.alm_users.get",
        variables: { sessionId: String(sessionId) },
      },
      "getAlmUsers",
      payload,
      { schema: searchAlmUsersResponseSchema, timeout },
    );
  }

  async setAlmUser(
    payload: SetAlmUserRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.jira.sessions.${sessionId}.alm_users.create",
        variables: { sessionId: String(sessionId) },
      },
      "setAlmUser",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getAlmUser(connectionId: string, timeout?: number): Promise<GetAlmUserResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.jira.connections.${connectionId}.user.get",
        variables: { connectionId: String(connectionId) },
      },
      "getAlmUser",
      {},
      { schema: getAlmUserResponseSchema, timeout },
    );
  }

  async getProjectSources(
    connectionId: string,
    timeout?: number,
  ): Promise<CamelToSnake<GetProjectSourcesResponse>> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.jira.connections.${connectionId}.project_sources.get",
        variables: { connectionId: String(connectionId) },
      },
      "getProjectSources",
      {},
      { timeout },
    );
  }

  async getKanbanConfigs(
    payload: GetKanbanConfigsRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<GetKanbanConfigsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.jira.connections.${connectionId}.kanban_configs.get",
        variables: { connectionId: String(connectionId) },
      },
      "getKanbanConfigs",
      payload,
      { schema: getKanbanConfigsResponseSchema, timeout },
    );
  }

  async getMapping(sessionId: string, timeout?: number): Promise<GetJiraMappingResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.jira.sessions.${sessionId}.sprint_mappings.get",
        variables: { sessionId: String(sessionId) },
      },
      "getMapping",
      {},
      { schema: getJiraMappingResponseSchema, timeout },
    );
  }

  async setMapping(
    payload: SetJiraMappingRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.jira.sessions.${sessionId}.sprint_mappings.set",
        variables: { sessionId: String(sessionId) },
      },
      "setMapping",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getArtTeamFieldMapping(
    connectionId: string,
    artId: number,
    timeout?: number,
  ): Promise<GetArtTeamFieldMappingResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.jira.connections.${connectionId}.arts.${artId}.team_field_mapping.get",
        variables: { connectionId: String(connectionId), artId: String(artId) },
      },
      "getArtTeamFieldMapping",
      {},
      { schema: getArtTeamFieldMappingResponseSchema, timeout },
    );
  }

  async setArtTeamFieldMapping(
    payload: SetArtTeamFieldMappingRequest,
    connectionId: string,
    artId: number,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.jira.connections.${connectionId}.arts.${artId}.team_field_mapping.set",
        variables: { connectionId: String(connectionId), artId: String(artId) },
      },
      "setArtTeamFieldMapping",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async syncSticky(
    payload: SyncStickyRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.jira.sessions.${sessionId}.sticky.sync",
        variables: { sessionId: String(sessionId) },
      },
      "syncSticky",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getDevLinks(
    payload: GetDevLinksRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<GetDevLinksResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.jira.sessions.${sessionId}.dev_links.get",
        variables: { sessionId: String(sessionId) },
      },
      "getDevLinks",
      payload,
      { schema: getDevLinksResponseSchema, timeout },
    );
  }

  async getJiraSessionKanbanBoard(
    sessionId: string,
    timeout?: number,
  ): Promise<GetJiraKanbanBoardResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.jira.sessions.${sessionId}.kanban_board.get",
        variables: { sessionId: String(sessionId) },
      },
      "getJiraSessionKanbanBoard",
      {},
      { schema: getJiraKanbanBoardResponseSchema, timeout },
    );
  }

  async setJiraSessionKanbanBoard(
    payload: SetJiraKanbanBoardRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.jira.sessions.${sessionId}.kanban_board.set",
        variables: { sessionId: String(sessionId) },
      },
      "setJiraSessionKanbanBoard",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getJiraSessionKanbanConfig(
    payload: GetJiraKanbanConfigRequest,
    sessionId: string,
    artId: number,
    timeout?: number,
  ): Promise<GetJiraKanbanConfigResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.jira.sessions.${sessionId}.arts.${artId}.kanban_config.get",
        variables: { sessionId: String(sessionId), artId: String(artId) },
      },
      "getJiraSessionKanbanConfig",
      payload,
      { schema: getJiraKanbanConfigResponseSchema, timeout },
    );
  }

  async getJiraBoards(
    payload: GetJiraBoardsRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<GetJiraBoardsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.jira.connections.${connectionId}.boards.get",
        variables: { connectionId: String(connectionId) },
      },
      "getJiraBoards",
      payload,
      { schema: getJiraBoardsResponseSchema, timeout: timeout ?? 45000 },
    );
  }
}
